<template>
  <div class="video-wrapper">
    <video
      class="player"
      ref="player"
      :controls="playing"
      :src="videoSrc"
      :poster="posterSrc"
    ></video>
    <div v-show="!playing" class="play-icon icomoon-triangle" @click="handlePlayIconClick"></div>
  </div>
</template>

<script>
export default {
  props: {
    videoSrc: {
      type: String
    },
    posterSrc: {
      type: String
    }
  },
  data () {
    return {
      playing: false
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.initVideoEvent()
  },
  methods: {
    initVideoEvent () {
      const videoPlayer = this.$refs.player

      videoPlayer.addEventListener('play', () => {
        this.playing = true
      })

      videoPlayer.addEventListener('pause', () => {
        this.playing = false
      })
    },
    handlePlayIconClick () {
      const videoPlayer = this.$refs.player
      videoPlayer.play()
    }
  }
}
</script>
<style lang="scss" scoped>
.video-wrapper {
  position: relative;

  .player {
    width: 100%;
    max-height: 600px;
    background-size: 100% 100%;
  }

  .play-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 60px;
    height: 60px;
    line-height: 60px;
    font-size: 30px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, .5);
    color: #fff;
    box-sizing: border-box;

    &::before {
      position: relative;
      left: 18px;
    }
  }

  @media screen and (min-width: 768px) {
    .player {
      max-height: 450px;
    }

    .play-icon {
      font-size: 55px;
      width: 100px;
      height: 100px;
      line-height: 100px;

      &::before {
        left: 28px;
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .play-icon {
      width: 110px;
      height: 110px;
      line-height: 107px;

      &::before {
        left: 32px;
      }
    }
  }
}

</style>
